<section class="main-content content-limitation" appAnimateOnScroll>
    <div class="fly-in-left">
        <img src="assets/img/personal-photos/profil-6.jpg" alt="portrait">
    </div>
    <div class="why-me-content">
        <div class="why-me-description">
            <h1>{{'why-me.title' | translate}}</h1>
            <p>
                {{'why-me.description' | translate}}
            </p>
        </div>
        <div class="mobile-arrow-left">
            <img src="assets/img/icons/arrow-bow-down.svg" alt="">
        </div>
        <div class="i-am-content">
            <div class="i-am-located">
                <h2>{{'why-me.i-am' | translate}}</h2>
                <div class="vector-imgs">
                    <img class="vector img-animation" src="assets/img/icons/vector.svg" alt="">
                    <img class="vector-hover img-animation" src="assets/img/icons/vector-hover.svg" alt="">
                    <p class="multiline">
                        {{'why-me.location' | translate}}
                    </p>
                </div>
            </div>
            <div class="i-am-relocate">
                <img src="assets/img/icons/arrow-bow-down.svg" alt="">
                <div class="suitcase-imgs">
                    <img class="suitcase img-animation" src="assets/img/icons/suitcase.svg" alt="">
                    <img class="suitcase-hover img-animation" src="assets/img/icons/suitcase-rotate.svg" alt="">
                    <p class="multiline">
                        {{'why-me.relocate' | translate}}
                    </p>
                </div>
            </div>
            <div class="i-am-remote">
                <div class="remote-imgs">
                    <img class="remote-icon img-animation-remote" src="assets/img/icons/remote.svg" alt="">
                    <img class="remote-hover img-animation-remote" src="assets/img/icons/remote-hover.svg" alt="">
                    <p class="multiline">
                        {{'why-me.remote' | translate}}
                    </p>
                    <img class="remote-arrow-up" src="assets/img/icons/arrow-bow-up.svg" alt="">
                </div>
                <img class="remote-arrow-down" src="assets/img/icons/arrow-curved-down.svg" alt="">
            </div>
        </div>
        <div class="mobile-arrow-right">
            <img src="assets/img/icons/arrow-i-am-mobile.svg" alt="">
        </div>
        <div class="i-am-talk">
            <button (click)="goToContact()">{{'why-me.talk-btn' | translate}}</button>
        </div>
    </div>
</section>